import makeStyles from '@mui/styles/makeStyles';

import { borderColor, darkGray, surfaceElevated } from '@/theme/colors';

export const useStyles = makeStyles({
  content: {
    padding: '10px 18px',
    borderBottom: `1px solid ${borderColor}`,
    backgroundColor: surfaceElevated,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  expertInfo: {
    flex: 1,
  },
  expertName: {
    fontSize: 16,
    fontWeight: 500,
    margin: 0,
    color: 'var(--onSurface)',
  },
  expertLocation: {
    fontSize: 13,
    color: darkGray,
    margin: 0,
  },
  signupCta: {
    fontSize: 13,
    color: darkGray,
    margin: '4px 0 0 0',
  },
});
